import { render, staticRenderFns } from "./PasswordRecoveryForm.vue?vue&type=template&id=58c209c0"
import script from "./PasswordRecoveryForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordRecoveryForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports